<section id="home" class="hero">
  <!-- Carousel Background -->
  <div class="carousel-container">
    <div 
      class="carousel-slide"
      *ngFor="let slide of slides; let i = index"
      [class.active]="i === currentSlide"
      [style.background-image]="'url(' + slide.image + ')'"
    >
      <div class="slide-overlay"></div>
    </div>
  </div>

  <!-- Hero Content -->
  <div class="container-fluid h-100">
    <div class="row h-100 align-items-center justify-content-center">
      <div class="col-12 col-md-12 col-lg-12">
        <div class="hero-content text-center animate-on-scroll">
          <h1 class="hero-title">{{ getCurrentSlide().title }}</h1>
          <p class="hero-subtitle">{{ getCurrentSlide().subtitle }}</p>
          <button 
            class="btn cta-button"
            (click)="scrollToServices()"
            aria-label="View our services"
          >
            VIEW SERVICES
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Carousel Controls -->
  <div class="carousel-controls d-flex">
    <button 
      class="carousel-btn prev-btn"
      (click)="prevSlide(); stopAutoSlide(); startAutoSlide()"
      aria-label="Previous slide"
    >
      &#8249;
    </button>
    <button 
      class="carousel-btn next-btn"
      (click)="nextSlide(); stopAutoSlide(); startAutoSlide()"
      aria-label="Next slide"
    >
      &#8250;
    </button>
  </div>

  <!-- Carousel Indicators -->
  <div class="carousel-indicators d-flex justify-content-center">
    <button
      *ngFor="let slide of slides; let i = index"
      class="indicator"
      [class.active]="i === currentSlide"
      (click)="goToSlide(i); stopAutoSlide(); startAutoSlide()"
      [attr.aria-label]="'Go to slide ' + (i + 1)"
    ></button>
  </div>
</section>